import HeroPlayer from './base-hero-player';

export default class YoutubeHeroPlayer extends HeroPlayer {
  constructor() {
    super();

    this.el = document.querySelector(`#${this.getMountSelector()}`);

    if (this.el) {
      this.player = new YT.Player(this.getMountSelector(), {
        videoId: this.el.getAttribute(`data-${HeroPlayer.TYPE.YOUTUBE}-id`),
        events: {
          'onStateChange': (e) => {
            if (e.data === 0) {
              this.toggleIframe();
            }
          },
        },
        height: '100%',
        width: '100%',
        playerVars: {
          autoplay: 0,
          iv_load_policy: 3,
          modestbranding: 1,
          playsinline: 1,
          rel: 0,
        }
      });
    }
  }

  play() {
    this.player.playVideo();
  }

  pauseVideoListener() {
    if (this.isVideoEnd())
      this.player.stopVideo();
    else
      this.player.pauseVideo();

    clearInterval(this.videoHeroPollerInterval);
    this.getHeroIframeContainer().removeEventListener('transitionend', this.pauseVideoListener);
  }

  getMountSelector() {
    return `${HeroPlayer.TYPE.YOUTUBE}-${HeroPlayer.SELECTOR_SUFFIX.PLAYER}`;
  }

  getHeroContainer() {
    return document.getElementById(`${HeroPlayer.TYPE.YOUTUBE}-${HeroPlayer.SELECTOR_SUFFIX.CONTAINER}`);
  }

  getHeroBadge() {
    return document.getElementById(`${HeroPlayer.TYPE.YOUTUBE}-${HeroPlayer.SELECTOR_SUFFIX.BADGE}`);
  }

  getHeroCover() {
    return document.getElementById(`${HeroPlayer.TYPE.YOUTUBE}-${HeroPlayer.SELECTOR_SUFFIX.COVER}`);
  }

  getHeroIframeContainer() {
    return document.getElementById(`${HeroPlayer.TYPE.YOUTUBE}-${HeroPlayer.SELECTOR_SUFFIX.IFRAME_CONTAINER}`);
  }
}